import styled from "styled-components";

export const Toolbar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const ControlsRow = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 16px;
`;

export const IntervalSlot = styled.div`
  margin-top: 20px;
`;

export const OptionsSlot = styled.div``;
